<!--
Considera pedidos de venda válidos (aberto ou faturado) agrupado por cliente



-->


<template>
  <div class="container-full-width default-container p-3">
    <filtro
        :showfiltro="showfiltro"
        :params="paramsFiltro" 
        @change="filtroChange"
        @cancel="handleCloseFiltro"
    />

    <div class="row">
      <div class="col-12 mb-2">
          <span class="lbl-deal-title mb-2 w-100">PERFORMANCE DA CARTEIRA DE CLIENTES NO PERÍODO</span>
          <v-button label="Retornar para visões" icon="fa-bar-chart" class="float-right" @click="clickRetornar"></v-button>
      </div>
    </div>
    <hr />
    <div class="row mb-3 align-items-center">
      <div class="col-md-6 col-12">
        <v-button label="Filtro" :success="true" @click="handleShowFiltro"></v-button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 p-3">
        <div class="border p-2">
          <span><i class="fa fa-exclamation"></i> Relação dos clientes que foram reativados no período informado</span>
        </div>
      </div>
    </div>

    <div class="row" v-if="clientes.length > 0">
      <div class="col-md-4 col-12 p-3" v-if="chartValues.length > 0">
        <span class="lbl-title mb-2">Resumo dos Clientes</span>
        <div class="p-4" style="border-top: 1px solid #dee2e6 !important; background: #fafafa">
            <span class="lbl-edit mb-5">Dos clientes que compraram esse mês:</span>
            <div v-for="(row, index) in grafico" :key="index">
                <div class="resumo__performance mb-3">
                    <span class="lbl-data">{{ row.label }}</span>
                    <span class="resumo__performance__value mr-2" :style="colorStatus(row.status)">{{ row.value | formatValue(0) }}%</span>
                </div>
            </div>
        </div>
      </div>
      <div class="col-md-8 col-12 p-3">
        <div class="lbl-title mb-2">Gráfico</div>
        <div class="" style="border-top: 1px solid #dee2e6 !important">
          <chart :params="paramsChart"></chart>
        </div>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-12 lbl-title mb-2">
        CLIENTES
        <v-button label="Excel" class="float-right" @click="loadData(true)"></v-button>
        <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-12" v-if="clientes.length == 0">
          Nenhum cliente encontrado
      </div>
      <div v-else class="col-12">
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
            <table class="table table-striped table-hover responsive tablesorter w-100">
                <thead>
                    <tr>
                        <th colspan="1" style="border: none"></th>
                        <th v-for="(periodo, index) in dados.periodos" :key="index" :colspan="colSpan(index)" class="text-center" style="border-bottom: none; border-left: 1px solid #dee2e6; border-right: 1px solid #dee2e6;">
                            <span>{{ periodo.label }}</span>
                        </th>
                    </tr>
                    <tr>
                      <template v-for="col in colunas">
                        <th v-if="col.visible" :class="col.class" :style="col.style">{{ col.label }}</th>
                      </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in clientes" :key="index">
                        <td v-if="colunas[0].visible" class="">{{ row.nome }}</td>
                        <td v-if="colunas[1].visible" class="">{{ row.id }}</td>
                        <td v-if="colunas[2].visible" class="">{{ row.fantasia }}</td>
                        <td v-if="colunas[3].visible" class="">{{ row.cnpjcpf | formatCNPJCPF }}</td>
                        <td v-if="colunas[4].visible" class="">{{ row.uf }}</td>
                        <td v-if="colunas[5].visible" class="">{{ row.ultimo_pedido | formatData }}</td>
                        <td v-if="colunas[6].visible" class="">{{ row.npedido }}</td>
                        <td v-if="colunas[7].visible" class="">{{ row.penultimo_pedido | formatData }}</td>
                        <td v-if="colunas[8].visible" class="numerico">{{ row.dias_sem_comprar }}</td>
                        <td v-if="colunas[8].visible" class="">{{ row.descricao_status }}</td>
                        <td v-if="colunas[9].visible" class="">{{ row.telefone | formatFone }}</td>
                        <td v-if="colunas[10].visible" class="">{{ row.email }}</td>
                        <td v-if="colunas[11].visible" class="">{{ row.segmento }}</td>
                        <td v-if="colunas[12].visible" class="">{{ row.nome_usuario }}</td>
                    </tr>
                </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashCard from "../dashboards/dash-card";
import Chart from "./chart";
import Filtro from "./filtro";
import { apiORDSpost } from "../shared/api-functions";
import { apiDownload2 } from "../shared/api-functions";

export default {
  components: {
    DashCard,
    Filtro,
    Chart,
  },

  data() {
    return {
      showfiltro: false,

      dados: {},
      grafico: null,

      color: ['#cd6155', '#a569bd', '#52be80', '#5dade2'],

      //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
      paramsFiltro: {
        periodo: {
          label: "Data da venda",
          varios: false,
          data_inicio: null,
          data_termino: null,
        },

        filtros: [
          { 
            nome: "usuario", 
            label: null, 
            url: null, 
            varios: true, 
            values: [] 
          },
          {
            nome: "segmento",
            label: null,
            url: null,
            varios: true,
            values: [],
          },
          {
            nome: "grupocliente",
            label: null,
            url: null,
            varios: true,
            values: [],
          },
          { 
            nome: "estado", 
            label: null, 
            url: null, 
            varios: true, 
            values: [] 
          },
        ],
      },

      filtro: {
        periodos: [{ data_inicio: null, data_termino: null }],
      },


      colunas: [
      ],

      mounting: false,

    };
  },

  watch: {},

  methods: {
    handleCloseFiltro(){
            this.showfiltro = false
        },
    clickRetornar () {
        this.$router.push('/')
    },

    montaColunas () {
        this.colunas = [
            { nome: 'nome', visible: true, label: 'Nome/Razão', sortable: true, orderby: null, class: '', style: 'min-width: 200px;' },
            { nome: 'id', visible: false, label: 'Código', sortable: true, orderby: null, class: '', style: '' },
            { nome: 'fantasia', visible: false, label: 'Fantasia', sortable: true, orderby: null, class: '', style: '' },
            { nome: 'cnpjcpf', visible: false, label: 'CNPJ/CPF', sortable: false, orderby: null, class: 'size130', style: '' },
            { nome: 'uf', visible: true, label: 'Estado', sortable: false, orderby: null, class: '', style: '' },
            { nome: 'ultimo_pedido', visible: true, label: 'Data Último Pedido', sortable: false, orderby: 'desc', class: 'size130', style: '' },
            { nome: 'npedido', visible: true, label: 'Último Pedido', sortable: false, orderby: null, class: '', style: '' },
            { nome: 'penultimo_pedido', visible: true, label: 'Penúltimo pedido', sortable: false, orderby: null, class: 'size130', style: '' },
            { nome: 'dias_sem_comprar', visible: true, label: 'Dias sem comprar', sortable: false, orderby: null, class: 'numerico', style: '' },
            { nome: 'descricao_status', visible: true, label: 'Status', sortable: false, orderby: null, class: 'size130', style: '' },
            { nome: 'telefone', visible: true, label: 'Telefone', sortable: false, orderby: null, class: 'size130', style: '' },
            { nome: 'email', visible: false, label: 'Email', sortable: false, orderby: null, class: 'size130', style: '' },
            { nome: 'segmento', visible: true, label: 'Segmento', sortable: false, orderby: null, class: 'size130', style: '' },
            { nome: 'nome_usuario', visible: true, label: 'Usuário', sortable: true, orderby: null, class: 'size130', style: '' },
        ]
    },

    colorStatus (status) {
      if (status == '4') 
        return 'background: ' + this.color[0]
      else
      if (status == '1') 
        return 'background: ' + this.color[2]
      else
      if (status == '3') 
        return 'background: ' + this.color[3]
      else
      if (status == '2') 
        return 'background: ' + this.color[1]
    },

    handleShowFiltro() {
      this.showfiltro = true;
    },

    filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;

      this.paramsFiltro.filtros[0].values = this.filtro.usuario
      this.paramsFiltro.filtros[1].values = this.filtro.segmento
      this.paramsFiltro.filtros[2].values = this.filtro.grupocliente
      this.paramsFiltro.filtros[3].values = this.filtro.estado

      this.loadData();
    },

    async loadData(excel) {
      
      let url = "consulta/vendas/performancedacarteira";

      this.filtro.excel = excel
      this.filtro.resumo = false

      if (excel) 
        apiDownload2(this, url, this.filtro, "post")
      else {
        const data = await apiORDSpost(this.$store, url, this.filtro, "post")
        if (data) {
          this.dados = data;
        } else {
          this.dados = {};
        }
        this.montaColunas()

        this.filtro.resumo = true
        const grafico = await apiORDSpost(this.$store, url, this.filtro, "post")
        if (grafico) {
          this.grafico = grafico.grafico;
        } else {
          this.grafico = {};
        }
      }
    },
  },

  computed: {
    clientes: function () {
      if (!this.dados.clientes) 
        return []
      else 
        return this.dados.clientes
    },

    paramsChart: function () {
      return { chart: { type: "PieChart" }, values: this.chartValues }
    },

    chartValues: function () {
      if (!this.grafico || this.grafico.length == 0)
        return []

      let values = [ ['', 'Quantidade de Clientes'] ]

      for (var x = 0; x < this.grafico.length; x++) {
          values.push([ this.grafico[x].label, this.grafico[x].value ])
      }

      return values
    },
  },

  mounted() {

  },

  created() {
    this.filtro.periodos[0].data_inicio = this.$lastDay(this.$getDate())
    this.filtro.periodos[0].data_termino = this.$firstDay(this.$getDate())

    if (this.$route.query.usuario) {
        this.filtro.usuario = [this.$route.query.usuario]
        this.paramsFiltro.filtros[0].values = [ this.filtro.usuario ]
    }

    if (this.$route.query.data_inicio) {
        this.filtro.periodos[0].data_inicio = this.$firstDay(this.$route.query.data_inicio)
        this.filtro.periodos[0].data_termino = this.$lastDay(this.$route.query.data_termino)
    }

    this.paramsFiltro.periodo.data_inicio = this.filtro.periodos[0].data_inicio
    this.paramsFiltro.periodo.data_termino = this.filtro.periodos[0].data_termino

    this.loadData()
  },
}


</script>

<style>
table .numerico {
  min-width: 65px;
  text-align: right;
}

table .size130 {
  min-width: 130px;
}

table .total {
    background: #c1c4c7;
    border: none;
}

table .var {
    min-width: 85px;
    text-align: center;
    background: #c1c4c7;
    display: inline-block;
}

table .var-negative {
    color: white;
    background: indianred;
}

table .var-positive {
    color: white;
    background: green;
}

table .border-left {
  border-left: 1px solid #dee2e6;
}

.resumo__performance {
  display: flex;
  align-items: center;
  justify-content: space-between;  
}

.resumo__performance__value {
    padding: 5px 15px;
    font-size: 18px;
    font-weight: 600;
    text-align: left;
    border-radius: 10%;
}

</style>



// WEBPACK FOOTER //
// src/consultas/consulta-vendas-performance-carteira.vue